import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import CustomerForm from 'ui-shared/FormComponents/CustomerForm'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import { Edit } from 'react-admin'
import { yupResolver } from '@hookform/resolvers/yup'
import { customerVS } from 'services/validations/crm/customer'

const PmiEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <CustomerForm
          toolbar={<WithDeleteModalToolbar />}
          resolver={yupResolver(customerVS)}
        />
      </Edit>
    </SectionWrapper>
  )
}

export default PmiEdit
